import { connect } from "react-redux";
import { Segment, Container, Grid, List, Image } from "semantic-ui-react";

const Footer = ({ constants: { external_urls } }) => {
  return (
    <Segment
      id="footer"
      inverted
      vertical
      attached
      style={{ position: "relative", padding: "2em 0em" }}
    >
      <Container fluid style={{ padding: "0 2em" }}>
        <Image
          src="/assets/giraffe_footer.png"
          style={{ position: "absolute", left: 0, bottom: 0, width: "31px" }}
        />
        <Grid inverted stackable>
          <Grid.Row>
            <Grid.Column width={4}>
              <List inverted>
                <List.Item>HireArt, Inc</List.Item>
                <List.Item>135 W 29th St. Suite 500</List.Item>
                <List.Item>New York NY 10001</List.Item>
              </List>
            </Grid.Column>
            <Grid.Column width={4}>
              <List link inverted>
                <List.Item as="a" href={external_urls?.blog} target="_blank">
                  Blog
                </List.Item>
                {/* <List.Item as='a' href={urls?.team} target='_blank'>About Us</List.Item> */}
                <List.Item
                  as="a"
                  href={external_urls?.terms_of_service}
                  target="_blank"
                >
                  Terms of Service
                </List.Item>
                <List.Item
                  as="a"
                  href={external_urls?.privacy_policy}
                  target="_blank"
                >
                  Privacy Policy
                </List.Item>
              </List>
            </Grid.Column>
            <Grid.Column width={4}>
              <List inverted>
                <List.Item>{`HireArt © ${new Date().getFullYear()}. All rights reserved.`}</List.Item>
              </List>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  );
};

const mapStateToProps = (state) => {
  return {
    constants: state.constants,
  };
};

export default connect(mapStateToProps)(Footer);
